module.exports = __webpack_public_path__ + "img/catalog-item-gap.webp";